export enum Locale {
    Nl = 'nl-BE',
    Fr = 'fr-BE',
    En = 'en-BE',
    EnUs = 'en-US',
}

export const defaultLocale = Locale.Nl;
